"use client";
import ReceiveStockView from "../components/ReceiveStockView.jsx";
import useReceiveStock from "../components/logic/useReceiveStock.jsx";

export default function ReceiveStock() {
  const props = useReceiveStock();
  return <ReceiveStockView {...props} />;
}
